import { faCheck, faPen, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import ModalBasic from '../component/ModalBasic.js';
import { PrintOtherDeliveryChallanById } from '../../services/axioServices/ApiEndPoints.js';
import { encryptionAPI } from '../../utils/Encryption.js';
import { APIURL } from '../../utils/AppSetting.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';

class OtherDeliveryChallan extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            isGridView: true,
            isLoading: false,
            tableStatus: "",
            setOtherDeliveryChallanModel: false,
            partyDropdownList: [],
            companyItemList: [],
            otherDeliveryChallanList: [],
            otherDeliveryChallanStockList: [],
            itemChallanDetailsList: [],
            validationStock: '',
            filterDetails: {
                partyName: "",
                arrangeBy: "Select",
            },
            challanDetails: {
                otherDeliveryChallanId: "",
                serialNo: "",
                returnDate: "",
                partyId: "",
            },
            itemChallanDetails: {
                itemChallanDetialsId: "",
                itemId: "",
                itemName: "",
                batchNo: "",
                qty: "",
                mfgDate: "",
                expDate: "",
                stockId: ""
            },
            arrangedByList: [
                { arrangedBy: "Sr. No.", value: "serialNo" },
                { arrangedBy: "Date", value: "returnDate" },
                { arrangedBy: "Party Name", value: "partyName" },
            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "partyId"
                        ),
                    },
                ],
                returnDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "returnDate"
                        ),
                    },
                ],


            },

            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForItem: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "itemId"
                        ),
                    },
                ],
                batchNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "batchNo"
                        ),
                    },
                ],
                qty: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "qty"
                        ),
                    },
                ],
            },
            validStateForItem: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getallOtherDeliveryChallanList()
    }

    getallOtherDeliveryChallanList = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.despatchServices.getallOtherDeliveryChallanList(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }

                this.setState({ otherDeliveryChallanList: res }, () => {
                    this.getAllPartyDropdown();
                });
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName,
                    state: item.state
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllItem();
                });
            } else {
                this.getAllItem();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllItem = () => {
        this.commonServices.getAllItem().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.ItemName,
                    value: item._id,
                    packing: item.Packing,
                    uom: item.UOM,
                    isNonInventory: item.NonInventoryItem,
                }));
                this.setState({ companyItemList: dropdownItems }, () => {
                });
            } else {
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemChallanDetails,
            this.state.validationRulesForItem,
            this.state.validStateForItem
        );
        this.setState({ validStateForItem: newValidState });
        return newValidState.isValid;
    };

    isValidAllFieldsForPartyDetails = () => {
        const newValidState = isValidForm(
            this.state.challanDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    closeGridView = () => {
        this.setState({ isGridView: false, itemChallanDetailsList: [] });
    };

    openGridView = () => {
        this.getallOtherDeliveryChallanList()
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.error = {}
        validState.isValid = true

        let validStateForItem = this.state.validStateForItem
        validStateForItem.error = {}
        validStateForItem.isValid = true

        let details = this.state.challanDetails
        details.serialNo = ''
        details.returnDate = ''
        details.partyId = ''
        details.otherDeliveryChallanId = ''

        let itemDetails = this.state.itemChallanDetails
        itemDetails.batchNo = ''
        itemDetails.itemId = ''
        itemDetails.qty = ''
        itemDetails.expDate = ''
        itemDetails.stockId = ''

        let filterDetails = this.state.filterDetails
        filterDetails.arrangeBy = "srNo"
        filterDetails.partyName = ""
        this.setState({
            challanDetails: details,
            filterDetails: filterDetails,
            validState: validState,
            itemChallanDetails: itemDetails,
            validStateForItem: validStateForItem
        })
    }
    resetItemDetalis = () => {
        let validState = this.state.validStateForItem
        validState.isValid = true
        validState.error = {}
        let details = this.state.itemChallanDetails
        details.itemChallanDetialsId = ''
        details.batchNo = ''
        details.itemId = ''
        details.qty = ''
        details.expDate = ''
        details.stockId = ''
        this.setState({
            itemChallanDetails: details,
            validStateForItem: validState
        })
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getallOtherDeliveryChallanList()
            });
        } else if (section === "challanDetails") {
            let details = this.state.challanDetails;
            details[name] = value.toUpperCase();
            this.setState({ challanDetails: details });
        } else if (section === 'itemChallanDetails') {
            let details = this.state.itemChallanDetails;
            details[name] = value.toUpperCase();
            this.setState({ itemChallanDetails: details });
        }
    };

    setFilterParameters = (selected, drpIdentity, section) => {
        if (section === 'challanDetails') {
            let details = this.state.challanDetails;
            details[drpIdentity] = selected.value;
            this.setState({ challanDetails: details })
        } else if (section === 'itemChallanDetails') {
            let details = this.state.itemChallanDetails;
            details[drpIdentity] = selected.value;
            details.itemName = selected.label
            this.setState({ itemChallanDetails: details }, () => {
                if (drpIdentity === 'itemId') {
                    this.getProductionStockByProductId(selected.value)
                }
            });
        }
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details }, () => {
            this.getallOtherDeliveryChallanList()
        });

    };

    getSerialNoForDeliveryChallan = () => {
        this.despatchServices.getSerialNoForDeliveryChallan().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.challanDetails
                details.serialNo = response.responseData.serialNo
                details.otherDeliveryChallanId = ''
                details.returnDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ challanDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setOpenModel = () => {
        this.setState({ setOtherDeliveryChallanModel: !this.state.setOtherDeliveryChallanModel });
    };

    getProductionStockByProductId = (id) => {
        this.despatchServices.getProductionStockByProductId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let resList = response.responseData
                resList = resList.filter(resItem => resItem.quantity > 0)

                if (resList.length > 0) {
                    this.setState({ otherDeliveryChallanStockList: resList, setOtherDeliveryChallanModel: true, validationStock: '' })
                } else {
                    this.setState({ otherDeliveryChallanStockList: [], validationStock: `Sorry, No Stock available for ${this.state.itemChallanDetails.itemName ? this.state.itemChallanDetails.itemName : 'this product'}.` })
                }
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    selectBatchStockForChallan = (item) => {
        let details = this.state.itemChallanDetails
        details.itemId = item.productId
        details.batchNo = item.batchNo
        details.qty = item.quantity
        details.mfgDate = item.mfgDate
        details.expDate = item.expDate
        details.stockId = item._id
        this.setState({ itemChallanDetails: details }, () => {
            this.setState({ setOtherDeliveryChallanModel: false })
        })
    }

    addEditDeliveryChallan = () => {
        let isValidAllFields = this.isValidAllFields();
        let isValidAllFieldsForPartyDetails = this.isValidAllFieldsForPartyDetails();
        if (isValidAllFields && isValidAllFieldsForPartyDetails) {
            this.setState({ isLoading: "save" }, () => {
                let request = {}
                request.challanDetails = this.state.challanDetails
                request.itemChallanDetails = this.state.itemChallanDetails
                this.despatchServices.addEditDeliveryChallan(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.setState({ isLoading: "" })
                        this.SwalServices.Success(response.Message)
                        let details = this.state.challanDetails
                        details.otherDeliveryChallanId = response.responseData.challanDetails._id
                        this.setState({ challanDetails: details }, () => {
                            this.getOtherDeliveryChallanDetailsById(this.state.challanDetails.otherDeliveryChallanId)
                            this.resetItemDetalis()
                        })
                    } else {
                        this.setState({ isLoading: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });

            })
        }
    }

    getOtherDeliveryChallanDetailsById = (id) => {
        this.despatchServices.getOtherDeliveryChallanDetailsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.challanDetails
                details.otherDeliveryChallanId = res.challanDetails._id
                details.serialNo = res.challanDetails.serialNo
                details.returnDate = moment(res.challanDetails.returnDate).format('YYYY-MM-DD')
                details.partyId = res.challanDetails.partyId._id


                let list = res.itemChallanDetailsList
                this.setState({ challanDetails: details, itemChallanDetailsList: list }, () => {
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    editItemChallanDetails = (item) => {
        let details = this.state.itemChallanDetails
        details.itemChallanDetialsId = item._id
        details.itemId = item.itemId._id
        details.itemName = item.itemId.ItemName
        details.batchNo = item.batchNo
        details.qty = item.qty
        details.expDate = moment(item.expDate).format('yyyy-MM-DD')
        details.stockId = item.stockId
        this.setState({ itemChallanDetails: details })
    }

    deleteItemDeliveryChallanById = (id) => {
        this.despatchServices.deleteItemDeliveryChallanById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getOtherDeliveryChallanDetailsById(this.state.challanDetails.otherDeliveryChallanId)
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteOtherDeliveryChallanById = (id) => {
        this.despatchServices.deleteOtherDeliveryChallanById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getallOtherDeliveryChallanList()
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    printDeliveryChallanByDeliveryChallanId = () => {
        this.setState({ isLoading: "print" }, () => {
            let id = this.state.challanDetails.otherDeliveryChallanId
            // let encryptId = encryptionAPI(id, 0)
            // window.open(APIURL + PrintOtherDeliveryChallanById + '?id=' + encryptId);
            let loginUser = getAuthProps();
            let headers = {
                Authorization: `Bearer ${loginUser.token}`,
                dbYear: loginUser.dbYear
            };
            let encryptId = encryptionAPI(id, 0)
            fetch(APIURL + PrintOtherDeliveryChallanById + '?id=' + encryptId, {
                method: 'GET',
                headers: headers
            })
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                })
        })
    }

    render() {
        return (
            <>
                <div className='otherDeliveryChallan-page'>
                    {this.state.isGridView === true ? (
                        <>
                            <div className="item-search mb-3.5">
                                <div className="item-grp !flex !gap-2.5">
                                    <div className="search-grp !w-[40%]">
                                        <div className="item-search-box">
                                            <label>Party Name</label>
                                            <input
                                                className="inputFocus"
                                                type="text"
                                                id="partyName"
                                                name="partyName"
                                                autoComplete="off"
                                                value={this.state.filterDetails.partyName}
                                                onChange={(event) =>
                                                    this.handleChange(event, "partyName", "filterDetails")
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="dropdown-grp !w-[20%]">
                                        <label>Arrange By</label>
                                        <select
                                            name="arrangeBy"
                                            value={this.state.filterDetails.arrangeBy}
                                            onChange={(e) =>
                                                this.handleDropDownChange(e, "arrangeBy")
                                            }
                                        >
                                            <option>Select</option>
                                            {this.state.arrangedByList.map((x, key) => (
                                                <option key={key} value={x.value}>
                                                    {x.arrangedBy}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <button className="add-btn mt-3.5" onClick={() => this.getSerialNoForDeliveryChallan()}>
                                    Add new
                                </button>
                            </div>
                            <div className="itemList-table">
                                <div className="table-container" style={{ height: "calc(100vh - 185px)" }}>
                                    <table className="itemList">
                                        <thead>
                                            <tr>
                                                <td style={{ width: '10%' }}>Sr. No</td>
                                                <td style={{ width: '20%' }}>Date</td>
                                                <td style={{ width: '50%' }}>Party Name</td>
                                                <td style={{ width: '20%', textAlign: 'center' }}>Action</td>
                                            </tr>
                                        </thead>
                                        {this.state.otherDeliveryChallanList && this.state.otherDeliveryChallanList.length > 0 ? (
                                            this.state.otherDeliveryChallanList.map((item, key) => (
                                                <tbody key={key}>
                                                    <tr>
                                                        <td>{item.serialNo}</td>
                                                        <td>{moment(item.returnDate).format('DD MMM yyyy')}</td>
                                                        <td>{item?.partyName}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <button
                                                                className="search-btn"
                                                                onClick={() => this.getOtherDeliveryChallanDetailsById(item._id)}
                                                            >
                                                                <FontAwesomeIcon icon={faPen} />
                                                            </button>
                                                            <button
                                                                className="cancel-btn ml-"
                                                                onClick={() =>
                                                                    this.deleteOtherDeliveryChallanById(item._id)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ))
                                        ) : this.state.otherDeliveryChallanList &&
                                            this.state.otherDeliveryChallanList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.otherDeliveryChallanList &&
                                            this.state.otherDeliveryChallanList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </table>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {this.state.isGridView === false ? (
                        <div className="item-listing">
                            <div className="item-form">
                                <div className="form-table">
                                    <div className="item-grp !mb-3">

                                        <div className="text-lg font-bold mb-[10px] text-gray-700">
                                            Party Details
                                        </div>
                                        <div className="item-inner-grp !flex gap-2.5 ">
                                            <div className="input-grp !min-w-[20%]">
                                                <label>Serial No.</label>
                                                <input
                                                    type="text"
                                                    id="serialNo"
                                                    name="serialNo"
                                                    disabled
                                                    autoComplete="off"
                                                    className="inputFocus"
                                                    value={this.state.challanDetails.serialNo}
                                                    onChange={(event) =>
                                                        this.handleChange(event, "serialNo", 'challanDetails')
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !min-w-[20%]">
                                                <label>Return Date</label>
                                                <input
                                                    type="date"
                                                    id="returnDate"
                                                    name="returnDate"
                                                    autoComplete="off"
                                                    disabled={!this.state.isMaterialDetailsEditing && this.state.isEditing}
                                                    className={`inputFocus ${this.state.validState?.error?.returnDate ? "errorInput" : ""}`}
                                                    value={this.state.challanDetails.returnDate}
                                                    onChange={(event) =>
                                                        this.handleChange(event, "returnDate", 'challanDetails')
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !w-full">
                                                <label>Party Name</label>
                                                <MultiSelectDropdown
                                                    drpIdentity="partyId"
                                                    className={` ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                                                    options={this.state.partyDropdownList}
                                                    closeMenuOnSelect={true}
                                                    hideSelectedOptions={false}
                                                    onChange={(selected) =>
                                                        this.setFilterParameters(selected, "partyId", "challanDetails")
                                                    }
                                                    allowSelectAll={false}
                                                    value={this.state.partyDropdownList.filter(
                                                        (party) =>
                                                            party.value === this.state.challanDetails.partyId
                                                    )}
                                                    isDisabled={this.state.isEditing}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="item-grp mt-2 grid">
                                        <div className="item-inner-grp mb-3 flex gap-2.5">
                                            <div className="input-grp w-[40%]">
                                                <div className="input-grp w-full">
                                                    <label>Item Name</label>
                                                    <MultiSelectDropdown
                                                        drpIdentity="itemId"
                                                        options={this.state.companyItemList}
                                                        className={` ${this.state.validStateForItem?.error?.itemId ? "errorInput" : ""}`}
                                                        closeMenuOnSelect={true}
                                                        hideSelectedOptions={false}
                                                        onChange={(selected) =>
                                                            this.setFilterParameters(
                                                                selected,
                                                                "itemId",
                                                                'itemChallanDetails'
                                                            )
                                                        }
                                                        allowSelectAll={false}
                                                        value={this.state.companyItemList.filter(
                                                            (party) => party.value === this.state.itemChallanDetails.itemId
                                                        )}
                                                    />
                                                </div>


                                            </div>
                                            <div className="input-grp !w-[15%]">
                                                <label>Batch No.</label>
                                                <input
                                                    type="text"
                                                    id="batchNo"
                                                    name="batchNo"
                                                    autoComplete="off"
                                                    disabled={true}
                                                    className={`inputFocus ${this.state.validStateForItem?.error?.batchNo ? "errorInput" : ""}`}
                                                    value={this.state.itemChallanDetails.batchNo}
                                                    onChange={(event) =>
                                                        this.handleChange(event, "batchNo", "itemChallanDetails")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !w-[15%]">
                                                <label>Quantity</label>
                                                <input
                                                    type="number"
                                                    id="qty"
                                                    name="qty"
                                                    autoComplete="off"
                                                    className={`inputFocus ${this.state.validStateForItem?.error?.qty ? "errorInput" : ""}`}
                                                    disabled={(this.state.isMaterialDetailsHide || this.state.isFromPurchaseMaterial)}
                                                    value={this.state.itemChallanDetails.qty}
                                                    onChange={(event) =>
                                                        this.handleChange(event, "qty", "itemChallanDetails")
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {this.state.validationStock !== '' ?
                                            <p className=' mb-3 w-fit p-2 rounded-[8px]'
                                                style={{
                                                    color: "brown",
                                                    fontSize: "13px",
                                                    border: "1px solid #a52a2a57",
                                                    outline: " 2px solid rgb(165 42 42 / 10%)",
                                                }} >
                                                {this.state.validationStock}</p>
                                            : null}
                                        <div className="btn-grp mb-3">
                                            {this.state.isMaterialDetailsEditing ?
                                                <button
                                                    disabled={this.state.isMaterialDetailsHide || this.state.isLoading}
                                                    className="add-btn"
                                                    onClick={() => this.addEditDeliveryChallan()}
                                                >
                                                    {this.state.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                                </button>
                                                :
                                                <button
                                                    disabled={this.state.isMaterialDetailsHide || this.state.isLoading}
                                                    className="add-btn"
                                                    onClick={() => this.addEditDeliveryChallan()}
                                                >
                                                    {this.state.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                                                </button>
                                            }
                                            <button
                                                disabled={this.state.isMaterialDetailsHide || this.state.isLoading}
                                                className="cancel-btn"
                                                onClick={() => { this.resetItemDetalis() }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="back-btn"
                                                onClick={() => this.openGridView()}
                                            >
                                                Back
                                            </button>
                                            {this.state.challanDetails.otherDeliveryChallanId !== '' && this.state.itemChallanDetailsList.length > 0 ?
                                                <button
                                                    className="print-btn"
                                                    disabled={this.state.isLoading}
                                                    onClick={() => this.printDeliveryChallanByDeliveryChallanId()}
                                                >
                                                    {this.state.isLoading === "print" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Print"}
                                                </button>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="innerTable">
                                    <div className="innerTable-container" style={{ height: "calc(100vh - 300px)" }} >
                                        <table className="innerList">
                                            <thead>
                                                <tr>
                                                    <td style={{ width: '30%' }}>Item Name</td>
                                                    <td style={{ width: '15%' }}>Batch No</td>
                                                    <td style={{ width: '15%' }}>Mfg. Date</td>
                                                    <td style={{ width: '15%' }}>Exp. Date</td>
                                                    <td style={{ width: '15%' }}>Quantity</td>
                                                    <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                                                </tr>
                                            </thead>
                                            {this.state.itemChallanDetailsList && this.state.itemChallanDetailsList.length > 0 ?
                                                this.state.itemChallanDetailsList.map((details, key) => (
                                                    <tbody key={key}>
                                                        <tr>
                                                            <td>{details.itemId.ItemName}</td>
                                                            <td>{details.batchNo}</td>
                                                            <td>{moment(details.mfgDate).format('MM/YYYY')}</td>
                                                            <td>{moment(details.expDate).format('MM/YYYY')}</td>
                                                            <td>{details.qty}</td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <button
                                                                    className="cancel-btn"
                                                                    onClick={() => this.deleteItemDeliveryChallanById(details._id)}
                                                                    disabled={details.isGSTPurchaseEntryRMPM}
                                                                >
                                                                    <FontAwesomeIcon className="h-[15px] w-[15px]" icon={faTrash} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )) :
                                                null
                                            }
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ) : null}
                </div>
                <ModalBasic
                    id="purchase-order-material-list"
                    modalOpen={this.state.setOtherDeliveryChallanModel}
                    setModalOpen={() => this.setOpenModel()}
                    title=""
                >
                    <div className="itemList-table">
                        <div className="table-container">
                            <table className="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: '10%' }}>Batch No</td>
                                        <td style={{ width: '35%' }}>Exp Date</td>
                                        <td style={{ width: '35%' }}>M.R.P.</td>
                                        <td style={{ width: '5%' }}>Stock</td>
                                        <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                                    </tr>
                                </thead>
                                {this.state.otherDeliveryChallanStockList && this.state.otherDeliveryChallanStockList.length > 0 ? (
                                    this.state.otherDeliveryChallanStockList.map((item, key) => (
                                        <tbody key={key}>
                                            <tr>
                                                <td>{item.batchNo}</td>
                                                <td>{moment(item.expDate).format("DD MMM yyyy")}</td>
                                                <td>{item.mrp}</td>
                                                <td>{item.quantity}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <button
                                                        className="search-btn"
                                                        onClick={() => this.selectBatchStockForChallan(item)}
                                                    >
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    ))
                                ) : (
                                    <tbody className="validation-body">
                                        <tr>
                                            <td
                                                colSpan={6}
                                                style={{ textAlign: "center", fontSize: "16px" }}
                                            >
                                                No Records Found
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </ModalBasic>
            </>
        );
    }
}

export default OtherDeliveryChallan;